import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { Grid } from "@material-ui/core";
import CustomModal from "../../components/common/customModal";
import CustomInput from "../../components/common/inputField";
import dashboardService from "../../services/DashboardServices";
import {
  RESocialForm,
  RESocialFormErrors,
  RESocialList,
} from "../../types/dashboard";
import { showToast } from "../../components/common/toastNotification";

interface RESocialProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  updatepReSocialData: RESocialList;
}

const RESocial: React.FC<RESocialProps> = ({
  open,
  onClose,
  onSave,
  updatepReSocialData,
}) => {
  const [formData, setFormData] = useState<RESocialForm>({
    id: null,
    socialMediaLink: "",
  });
  const [formErrors, setFormErrors] = useState({
    socialMediaLink: "",
  });

  useEffect(() => {
    if (open) {
      if (Object.keys(updatepReSocialData).length > 0) {
        setFormData({
          id: updatepReSocialData.id || null,
          socialMediaLink: updatepReSocialData.socialMediaLink || "",
        });
      } else {
        setFormData({
          id: null,
          socialMediaLink: "",
        });
      }
      setFormErrors({
        socialMediaLink: "",
      });
    }
  }, [updatepReSocialData, open]);

  //// input onchange code
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  /// handle Form validation code
  const validateForm = () => {
    const errors: RESocialFormErrors = {};

    if (!formData.socialMediaLink.trim()) {
      errors.socialMediaLink = "URL of Social Media Platform is required.";
    }

    setFormErrors({
      socialMediaLink: errors.socialMediaLink || "",
    });
    return Object.keys(errors).length === 0;
  };

  const handleSaveData = async () => {
    if (!validateForm()) return;
    try {
      const { id, socialMediaLink } = formData;

      const inputData = {
        Id: Number(id),
        SocialMediaLink: socialMediaLink.trim(),
      };

      await dashboardService
        .updateRESocialDataAPI(inputData)
        .then((response) => {
          if (response && response.data) {
            showToast(response.data.message, "success");
            onSave();
            onClose();
          } else {
            showToast(response?.data?.message, "error");
          }
        })
        .catch((error) => {
          console.error("Error", error);
        });
    } catch (error) {
      console.error("Error saving RE Social data:", error);
    }
  };

  return (
    <CustomModal
      open={open}
      handleClose={onClose}
      onSave={handleSaveData}
      title="RE Social"
    >
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CustomInput
              label="URL of Social Media Platform"
              type="text"
              name="socialMediaLink"
              placeholder="Enter the URL of Social Media Platform"
              value={formData.socialMediaLink}
              onChange={handleChange}
              error={formErrors.socialMediaLink}
              required
            />
          </Grid>
        </Grid>
      </Box>
    </CustomModal>
  );
};

export default RESocial;
